var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontEndAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(14 13)",
    d: "M7.5 1C8.328125 1 9 1.6715622 9 2.5L9 13.5C9 14.328125 8.328125 15 7.5 15L6.5 15C5.671875 15 5 14.328125 5 13.5L5 2.5C5 1.6715622 5.671875 1 6.5 1L7.5 1ZM7.5 2.5L6.5 2.5L6.5 13.5L7.5 13.5L7.5 2.5ZM2.5 7C3.328125 7 4 7.671875 4 8.5L4 13.5C4 14.328125 3.328125 15 2.5 15L1.5 15C0.67156267 15 0 14.328125 0 13.5L0 8.5C0 7.671875 0.67156267 7 1.5 7L2.5 7ZM2.5 8.5L1.5 8.5L1.5 13.5L2.5 13.5L2.5 8.5ZM10 4.5C10 3.671875 10.671875 3 11.5 3L12.5 3C13.328125 3 14 3.671875 14 4.5L14 13.5C14 14.328125 13.328125 15 12.5 15L11.5 15C10.671875 15 10 14.328125 10 13.5L10 4.5ZM11.5 13.5L12.5 13.5L12.5 4.5L11.5 4.5L11.5 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontEndAnalytics);
export default __webpack_public_path__ + "static/media/frontEndAnalytics.0d3fc1a061fa2c48c13f230679892cec.svg";
export { ForwardRef as ReactComponent };